import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { Layout } from "../components/Navbar";
import { api, getUser, canClinical } from "../api";
import { toast } from "sonner";

// Bio parziale del follower, visibile SOLO alla struttura attualmente seguita.
// Sola lettura, sette campi (Nome, Cognome, Codice fiscale, Età, Residenza, Telefono, Email). Autorizzazione lato backend.
function Row({ label, v, testid }) {
  const { t } = useTranslation();
  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <div className="mt-1 break-words" data-testid={testid}>{v || <span className="text-slate-400 italic">{t("hbio.not_set")}</span>}</div>
    </div>);
}

export default function OrgBio() {
  const { t } = useTranslation();
  const { patientId } = useParams();
  const [bio, setBio] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/users/${patientId}/org-bio`).then(({ data }) => setBio(data.bio))
      .catch((e) => { setErr(true); toast.error(e.response?.data?.detail || t("orgbio.error")); });
  }, [patientId]);
  if (err) return <Layout><div className="yp-container py-8 text-red-600" data-testid="orgbio-error">{t("orgbio.error")}</div></Layout>;
  if (!bio) return <Layout><div className="yp-container py-8">{t("common.loading")}</div></Layout>;
  return (<Layout><div className="yp-container max-w-2xl py-8" data-testid="org-bio-page">
    <div className="flex items-center gap-4 mb-4 flex-wrap" data-testid="bio-nav">
      <Link to={`/chat/${patientId}`} className="inline-flex items-center gap-1 text-sm text-blue-600 hover:underline" data-testid="bio-back-chat"><ArrowLeft size={16} aria-hidden="true" /> {t("followx.back_to_chat")}</Link>
      {canClinical(getUser()) && <Link to={`/clinica/${patientId}`} className="text-sm text-blue-600 hover:underline" data-testid="bio-clinical-link">{t("followx.clinical")}</Link>}
    </div>
    <h1 className="text-3xl font-bold mb-2">{t("orgbio.title")}</h1>
    <p className="text-sm text-slate-500 mb-4">{t("orgbio.subtitle")}</p>
    <div className="yp-card p-6 grid md:grid-cols-2 gap-3">
      <Row label={t("orgbio.first")} v={bio.first_name} testid="orgbio-first" />
      <Row label={t("orgbio.last")} v={bio.last_name} testid="orgbio-last" />
      <Row label={t("orgbio.cf")} v={bio.tax_id} testid="orgbio-cf" />
      <Row label={t("orgbio.age")} v={bio.age != null ? String(bio.age) : ""} testid="orgbio-age" />
      <Row label={t("orgbio.residence")} v={bio.residence} testid="orgbio-residence" />
      <Row label={t("orgbio.phone")} v={bio.phone} testid="orgbio-phone" />
      <Row label={t("orgbio.email")} v={bio.email} testid="orgbio-email" />
    </div>
  </div></Layout>);
}
